import React from "react";

const Grupos = ({
  notifyColor,
  campanha,
  gruposFiltrados,
  gruposSelecionados,
  setGruposSelecionados,
  grupoPesquisa,
  setGrupoPesquisa,
  mostrarGrupos,
  setMostrarGrupos,
  handleSelecionarGrupo,
  handleSelecionarTodosGrupos,
  setEtapaAtual,
  etapaAtual,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column", // Organiza o conteúdo verticalmente
        alignItems: "center", // Centraliza o conteúdo horizontalmente
        justifyContent: "flex-start", // Alinha o conteúdo mais acima
        minHeight: "100vh", // Garante que o componente ocupe a altura total da tela
        padding: "20px", // Espaçamento interno
        boxSizing: "border-box",
        background: "#f7f7f7", // Cor de fundo para destacar o conteúdo
        marginTop: "-30px", // Move o conteúdo mais para cima
      }}
    >
      <h3
        style={{
          color: notifyColor,
          marginBottom: 24,
          textAlign: "center",
        }}
      >
        Selecione para onde enviar
      </h3>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 24,
          width: "100%",
          maxWidth: 480,
          alignItems: "center", // Centraliza o conteúdo dentro do contêiner
        }}
      >
        {/* Mostrar campanha selecionada */}
        <div
          style={{
            background: "#f0f4f8",
            borderRadius: 12,
            padding: 16,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            alignItems: "center",
            gap: 16,
            width: "100%",
          }}
        >
          <div
            style={{
              position: "relative",
              width: 56,
              height: 56,
              marginRight: 12,
            }}
          >
            <img
              src={campanha.capa}
              alt={campanha.nome}
              style={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #51a197",
              }}
            />
            <span
              style={{
                position: "absolute",
                bottom: 4,
                right: 4,
                width: 16,
                height: 16,
                borderRadius: "50%",
                background: "#28a745",
                boxShadow: "0 0 8px 2px #28a745",
                animation: "pulse 1.2s infinite",
              }}
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: "bold",
                color: "#005c53",
                fontSize: 18,
              }}
            >
              {campanha.nome}
            </div>
            <div style={{ fontSize: 13, color: "#888" }}>
              Enviar para toda a campanha
            </div>
          </div>
        </div>
        {/* Botão para mostrar grupos */}
        <button
          type="button"
          onClick={() => setMostrarGrupos(!mostrarGrupos)}
          style={{
            background: "#e0e0e0",
            color: "#005c53",
            border: "none",
            borderRadius: 8,
            padding: "8px 16px",
            fontWeight: "bold",
            fontSize: 15,
            cursor: "pointer",
            marginTop: 8,
            marginBottom: 0,
            transition: "background 0.2s",
            width: "100%",
          }}
        >
          {mostrarGrupos ? "Ocultar grupos" : "Selecionar grupos específicos"}
        </button>
        {/* Grupos específicos */}
        {mostrarGrupos && (
          <div
            style={{
              background: "#f0f4f8",
              borderRadius: 12,
              padding: 16,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              width: "100%",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                color: "#333",
                marginBottom: 8,
              }}
            >
              Enviar para grupos específicos
            </div>
            <input
              type="text"
              placeholder="Pesquisar grupo..."
              value={grupoPesquisa}
              onChange={(e) => setGrupoPesquisa(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid #e0e0e0",
                marginBottom: 12,
                fontSize: 15,
              }}
            />
            <div style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                checked={
                  gruposSelecionados.length === gruposFiltrados.length &&
                  gruposFiltrados.length > 0
                }
                onChange={handleSelecionarTodosGrupos}
                style={{
                  accentColor: notifyColor,
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                  marginRight: 8,
                }}
                id="selecionarTodosGrupos"
              />
              <label
                htmlFor="selecionarTodosGrupos"
                style={{
                  fontWeight: "bold",
                  color: "#005c53",
                  cursor: "pointer",
                }}
              >
                Selecionar todos os grupos
              </label>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {gruposFiltrados.length === 0 && (
                <span style={{ color: "#888", fontStyle: "italic" }}>
                  Nenhum grupo encontrado.
                </span>
              )}
              {gruposFiltrados.map((grupo) => (
                <div
                  key={grupo.id}
                  style={{
                    background: "#fff",
                    borderRadius: 12,
                    padding: 12,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    transition: "background 0.2s",
                    cursor: "pointer",
                    width: "100%",
                  }}
                  onClick={() => handleSelecionarGrupo(grupo.id)}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <input
                      type="checkbox"
                      checked={gruposSelecionados.includes(grupo.id)}
                      onChange={() => {}}
                      style={{
                        accentColor: notifyColor,
                        width: 20,
                        height: 20,
                        cursor: "pointer",
                        marginRight: 8,
                      }}
                    />
                    <div style={{ fontWeight: "bold", color: "#005c53" }}>
                      {grupo.nome}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <style>
        {`
          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 #51a197; }
            70% { box-shadow: 0 0 8px 6px #51a19744; }
            100% { box-shadow: 0 0 0 0 #51a197; }
          }
        `}
      </style>
      <button
        style={{
          marginTop: 32,
          background: "#51a197",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          padding: "12px 32px",
          fontWeight: "bold",
          fontSize: 17,
          cursor: "pointer",
          alignSelf: "center", // Centraliza o botão horizontalmente
        }}
        onClick={() => setEtapaAtual(etapaAtual + 1)}
      >
        Próximo
      </button>
    </div>
  );
};

export default Grupos;